import React, { createContext, useCallback, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import mainStyle from "assets/jss/components/mainStyle";
import { emptyObject } from "constants/defaultValues";

const useStyles = makeStyles(mainStyle);

export const ContentContext = createContext();

function Main({ children }) {
  const [state, setState] = useState(emptyObject);
  const showFooter = Boolean(state?.footer);
  const showHeader = Boolean(state?.header);
  const styleProps = useMemo(() => ({ showFooter, showHeader }), [showFooter, showHeader]);
  const classes = useStyles(styleProps);
  const setHeader = useCallback((value) => setState((prevValue) => ({ ...prevValue, header: value })), []);
  const setFooter = useCallback((value) => setState((prevValue) => ({ ...prevValue, footer: value })), []);
  const contextValue = useMemo(() => ({ ...state, setHeader, setFooter }), [state, setHeader, setFooter]);

  return (
    <ContentContext.Provider value={contextValue}>
      <div className={classes.container}>
        {styleProps.showHeader && <div className={classes.contentHeader}>{state.header}</div>}
        <div className={classes.content}>{children}</div>
        {styleProps.showFooter && <div className={classes.contentFooter}>{state.footer}</div>}
      </div>
    </ContentContext.Provider>
  );
}

Main.propTypes = { children: PropTypes.node.isRequired };

export default Main;
